import { Injectable } from "@angular/core";
import { PaymentService } from "../../../../services/payment.service";
import { AddCardComponent } from "../add-card.component";
import { Data } from "@angular/router";

@Injectable()
export class CheckoutUpsellService {
  constructor(private paymentService: PaymentService) {}

  getUpsellData(componentContext : AddCardComponent, upsell_ID: string, selectedUpsells?: Data[]) {
    try {
      this.paymentService.getUpsellList(upsell_ID).subscribe((data) => {
        if (data?.upsell_list) {
          const upsellData = data?.upsell_list;

          // Add isChecked property
          componentContext.upsellList = upsellData.map((value: Data) => {
            if (selectedUpsells?.some((upsell) => upsell.offer_id === value.offer_id)) {
              value.isChecked = true;
            } else {
              value.isChecked = false;
            }
            return value;
          });
        }
      });
    } catch (error) {
      return error;
    }
  }

  checkBoxChanged(componentContext: AddCardComponent, event: Data, offerData: Data) {
    const isChecked = event?.detail?.checked;
    const prizeValue = event?.detail?.value;
    const prizeValueDefault = offerData?.price?.["GBP"];

    if (isChecked) {
      // If the checkbox is checked, add the calculated additionOfPrize to the array of checkedValues

      componentContext.checkedValues.push(prizeValue);
      componentContext.checkedValuesDefaultCurrency.push(prizeValueDefault);

      componentContext.addonAmount.push({
        offer_id: offerData.offer_id,
        value: offerData.price?.["GBP"],
        product_description: offerData?.product_description || "offer",
        preferred_currency: {
          Value: offerData.price?.[componentContext.preferredCurrency],
          currency: componentContext.preferredCurrency,
        },
      });
      componentContext.upsellSummaryArray.push({
        offer_id: offerData.offer_id ?? "",
        summary_content: offerData?.summary_content ?? {},
        product_description: offerData?.product_description || "offer",
      });
      const purchaseDetail = { ...componentContext.purchaseDetail$.value, add_on: componentContext.addonAmount };
      componentContext.purchaseDetail$.next(purchaseDetail);
    } else {
      // If the checkbox is unchecked, remove the original prizeValue from the array of checkedValues
      const index = componentContext.checkedValues.indexOf(prizeValue);
      if (index !== -1) {
        componentContext.checkedValues.splice(index, 1);
        componentContext.checkedValuesDefaultCurrency?.splice(index, 1);
      }
      const offerIdToRemove = offerData?.offer_id;
      componentContext.addonAmount = componentContext.addonAmount?.filter(
        (addon: Data) => addon?.offer_id !== offerIdToRemove,
      );
      componentContext.upsellSummaryArray = componentContext.upsellSummaryArray?.filter(
        (addon: Data) => addon?.offer_id !== offerIdToRemove,
      );
      const purchaseDetail = { ...componentContext.purchaseDetail$.value, add_on: componentContext.addonAmount };
      componentContext.purchaseDetail$.next(purchaseDetail);
    }
    // Calculate the total prize by summing the values of all checked checkboxes
    const totalPrizeValues = componentContext.checkedValues?.reduce(
      (acc: number, currentValue: number) => acc + Number(currentValue),
      0,
    );
    componentContext.totalAmount = totalPrizeValues;
    const totalPrize = Number(totalPrizeValues.toFixed(2));
    componentContext.updatedPrizeValue = totalPrize;
  }
}
